export default {
  apiUrl: {
    local: 'https://nodeproxy.alley.dev',
    staging: 'https://datacenter.prb.org',
    production: 'https://datacenter.prb.org',
  },
  wpUrl: {
    development: 'https://prb.alley.ws',
    local: 'https://prb-2017.alley.dev',
    staging: 'https://h7.prb.org',
    production: 'https://www.prb.org',
  },
  title: {
    usdata: 'United States Indicators',
    international: 'International Data',
  },
  landingPage: {
    title: {
      usdata: 'Browse by indicator or state',
      international: 'Browse by indicator, country or region',
    },
    mapTitle: {
      usdata: 'View indicators by state',
      international: 'View indicators by country or region',
    },
  },
};



// WEBPACK FOOTER //
// ./app/config/appConfig.js